// Import action types related to videos
import {
  VIDEO_FETCH_DATA_SUCCESS,
  VIDEO_HAVE_ERROR,
  VIDEO_ARE_LOADING,
} from "../actionType";

// Define the initial state for the Video reducer
const initialState = {
  data: [], // Initialize data as an empty array
  loading: true, // Set loading to true initially
  error: [], // Initialize error as an empty array
};

// Reducer function to handle video-related actions and update state accordingly
export function VideoReducer(state = initialState, action) {
  switch (action.type) {
    // Handle error case when fetching videos
    case VIDEO_HAVE_ERROR:
      return {
        ...state,
        error: action.hasError, // Update the error state with the error from the action
        loading: false, // Set loading to false since the request is complete
      };

    // Handle loading state when videos are being fetched
    case VIDEO_ARE_LOADING:
      return {
        ...state,
        loading: action.isLoading, // Update the loading state with the loading status from the action
      };

    // Handle success case when videos are successfully fetched
    case VIDEO_FETCH_DATA_SUCCESS:
      return {
        ...state,
        data: action.Video, // Update the data state with the fetched videos
        loading: false, // Set loading to false since the request is complete
        error: [], // Clear any previous errors (assuming the success case means no error)
      };

    // Return the current state by default if action type is not recognized
    default:
      return state;
  }
}
